document.addEventListener("DOMContentLoaded", function () {
  // Scope to the collection-page carousel containers and self-gate on
  // element presence. The previous `.swiper` selector was too generic:
  // the homepage slideshow hero carries `class="slideshow__swiper ... swiper ..."`,
  // so `new Swiper('.swiper', ...)` was grabbing it and double-
  // initializing Swiper on top of what slideshow.js had already done.
  // That double-init was the second `swiper-bundle.min.js:13` "Forced
  // reflow" entry PageSpeed reported on the homepage. Same gating
  // pattern is applied to .brand-swiper so off-collection templates do
  // not pay swiper-bundle internal layout reads against a missing
  // element.
  const carouselEl = document.querySelector('.other-collections-swiper');
  if (carouselEl) {
    const swiper = new Swiper(carouselEl, {
      loop: false,
      spaceBetween: 10,
      grabCursor: true,
      centeredSlides: false,
      navigation: {
        nextEl: '.collection-swiper-next',
        prevEl: '.collection-swiper-prev'
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        0: { slidesPerView: 1 },
        600: { slidesPerView: 2 },
        1000: { slidesPerView: 6 },
      }
    });
  }

  const brandEl = document.querySelector('.brand-swiper');
  if (brandEl) {
    const brand_swiper = new Swiper(brandEl, {
      loop: false,
      spaceBetween: 0,
      grabCursor: true,
      centeredSlides: false,
      navigation: {
        nextEl: '.brand-swiper-next',
        prevEl: '.brand-swiper-prev'
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        0: { slidesPerView: 1 },
        480: { slidesPerView: 2 },
        768: { slidesPerView: 2 },
        1045: { slidesPerView: 3 },
        2400: { slidesPerView: 4 }
      }
    });
  }
});
